import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import demo from '@/pages/demo'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      component: resolve => require(['../pages/home'], resolve),
    },
    {
      path: '/consultation',
      name: 'consultation',
      component: resolve => require(['../pages/consultation'], resolve),
      meta: { title: '购车咨询' }
    }, 
	   {
      path: '/about',
      name: 'about',
      component: resolve => require(['../pages/about'], resolve),
      meta: { title: '柳州五菱新能源汽车有限公司' }
    }, 
	{
      path: '/contactUs',
      name: 'contactUs',
      component: resolve => require(['../pages/contactUs'], resolve),
      meta: { title: '联系我们' }
    }, {
      path: '/service',
      name: 'service',
      component: resolve => require(['../pages/service'], resolve),
      meta: { title: '菱势服务' }
    }, {
      path: '/introduce',
      name: 'introduce',
      component: resolve => require(['../pages/introduce'], resolve),
      meta: { title: '公司介绍' }
    }, {
      path: '/story',
      name: 'story',
      component: resolve => require(['../pages/story'], resolve),
      meta: { title: '品牌故事' }
    }, {
      path: '/investor',
      name: 'relation1',
      component: resolve => require(['../pages/relation'], resolve),
      meta: { title: '股东信息' }
    },
    {
      path: '/manager',
      name: 'relation2',
      component: resolve => require(['../pages/relation2'], resolve),
      meta: { title: '投资者关系' }
    },
    {
      path: '/directorate',
      name: 'relation3',
      component: resolve => require(['../pages/relation3'], resolve),
      meta: { title: '投资者关系' }
    },
    {
      path: '/address',
      name: 'relation4',
      component: resolve => require(['../pages/relation4'], resolve),
      meta: { title: '投资者来访互动' }
    }, {
      path: '/news',
      name: 'news',
      component: resolve => require(['../pages/news'], resolve),
      meta: { title: '资讯中心' }
    }, {
      path: '/newsDetail',
      name: 'newsDetail',
      component: resolve => require(['../pages/newsDetail'], resolve),
      meta: { title: '资讯详情' }
    }, {
      path: '/cooperate',
      name: 'cooperate',
      component: resolve => require(['../pages/cooperate'], resolve),
      meta: { title: '加盟合作' }
    }, {
      path: '/product',
      name: 'product1',
      component: resolve => require(['../pages/product1'], resolve),
      meta: { title: '菱势EV50' }
    },
    {
      path: '/product2',
      name: 'product2',
      component: resolve => require(['../pages/product2'], resolve),
      meta: { title: '菱势仓栅车' }
    },
    {
      path: '/product3',
      name: 'product3',
      component: resolve => require(['../pages/product3'], resolve),
      meta: { title: '菱势单双层货柜' }
    },
	    {
      path: '/weixin',
      name: 'weixin',
      component: resolve => require(['../pages/weixin'], resolve),
      meta: { title: '菱势微信公众号二维码' }
    },
	
	 {
      path: '/400',
      name: '400',
      component: resolve => require(['../pages/400'], resolve),
      meta: { title: '菱势汽车服务热线' }
    },
    {
      path: '/product5',
      name: 'product5',
      component: resolve => require(['../pages/product5'], resolve),
      meta: { title: '菱势黄金卡' }
    },
	    {
      path: '/product7',
      name: 'product7',
      component: resolve => require(['../pages/product7'], resolve),
      meta: { title: '菱势黄金卡双排' }
    },
	
	   {
      path: '/product9',
      name: 'product9',
      component: resolve => require(['../pages/product9'], resolve),
      meta: { title: '菱势黄金小卡' }
    },
	
	    {
      path: '/product8',
      name: 'product8',
      component: resolve => require(['../pages/product8'], resolve),
      meta: { title: 'EV50客运版' }
    },
	    {
      path: '/product6',
      name: 'product6',
      component: resolve => require(['../pages/product6'], resolve),
      meta: { title: '黄金仓' }
    },
	
	  {
      path: '/product11',
      name: 'product11',
      component: resolve => require(['../pages/product11'], resolve),
      meta: { title: '菱势黄金大卡' }
    },
	
	  {
      path: '/product12',
      name: 'product12',
      component: resolve => require(['../pages/product12'], resolve),
      meta: { title: '菱势黄金小卡PLUS' }
    },
	 {
      path: '/product10',
      name: 'product10',
      component: resolve => require(['../pages/product10'], resolve),
      meta: { title: '黄金仓PLUS' }
    },
    {
      path: '/dealerSearch',
      name: 'product4',
      component: resolve => require(['../pages/product4'], resolve),
      meta: { title: '经销商查询' }
    },
    {
      path: '/demo',
      name: 'demo',
      component: resolve => require(['../pages/demo'], resolve),
      meta: { title: '模板' }
    },
    {
      path: '/dealer',
      name: 'dealer',
      component: resolve => require(['../pages/dealer'], resolve),
      meta: { title: '菱势线下体验店' }
    },
    {
      path: '/supplier',
      name: 'supplier',
      component: resolve => require(['../pages/supplier'], resolve),
      meta: { title: '特约服务站' }
    },
    {
      path: '/ser',
      name: 'ser',
      component: resolve => require(['../pages/ser'], resolve),
      meta: { title: '服务支持' }
    },
    {
      path: '/join',
      name: 'join',
      component: resolve => require(['../pages/join'], resolve),
      meta: { title: '加入我们' }
    },
    {
      path: '/serActivity',
      name: 'serActivity',
      component: resolve => require(['../pages/serActivity'], resolve),
      meta: { title: '服务活动' }
    },

    {
      path: '/news1',
      name: 'news1',
      component: resolve => require(['../pages/news1'], resolve),
      meta: { title: '新闻资讯' }
    }, 
    {
      path: '/news2',
      name: 'news2',
      component: resolve => require(['../pages/news2'], resolve),
      meta: { title: '行业资讯' }
    },

    {
      path:'/agreement',
      name:'agreement',
      component: resolve => require(['../pages/agreement'], resolve),
      meta: { title: '隐私政策' }
    }




  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js